(()=>{
function init(root=document){
root.querySelectorAll('[data-nt-catalogue]').forEach(catalogue=>{
 if(catalogue.dataset.initialized)return;catalogue.dataset.initialized='true';
 const buttons=catalogue.querySelectorAll('[data-nt-filter]');
 buttons.forEach(button=>button.addEventListener('click',()=>{
  buttons.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
  let visible=0;catalogue.querySelectorAll('[data-nt-card]').forEach(card=>{card.hidden=button.dataset.ntFilter!=='all'&&card.dataset.category!==button.dataset.ntFilter;if(!card.hidden)visible++});
  catalogue.querySelector('[data-nt-empty]').hidden=visible>0;
 }));
});
root.querySelectorAll('[data-nt-product]').forEach(product=>{
 if(product.dataset.initialized)return;product.dataset.initialized='true';
 product.querySelectorAll('[data-nt-thumb]').forEach(button=>button.addEventListener('click',()=>{
 product.querySelectorAll('[data-nt-slide]').forEach(slide=>slide.hidden=slide.dataset.ntSlide!==button.dataset.ntThumb);
 product.querySelectorAll('[data-nt-thumb]').forEach(thumb=>thumb.setAttribute('aria-pressed',String(thumb===button)));
 }));
 product.querySelectorAll('[data-nt-size-request]').forEach(link=>link.addEventListener('click',()=>{
  const field=product.querySelector('#nt-message');if(!field)return;
  const text=product.querySelector('[data-nt-size-text]').textContent;
  if(!field.value.includes(text))field.value+=(field.value?'\n':'')+text;
  product.querySelector('.nt-optional:not(.nt-extras)').open=true;
 }));
});
root.querySelectorAll('#TeamwearEnquiry').forEach(form=>{
 if(form.dataset.initialized)return;form.dataset.initialized='true';
 const extras=form.querySelectorAll('[data-nt-extra]');const sync=()=>{const field=form.querySelector('#nt-additional');if(field)field.value=Array.from(extras).filter(input=>input.checked).map(input=>input.value).join('; ')};
 extras.forEach(input=>input.addEventListener('change',sync));form.addEventListener('submit',sync);
 if(form.querySelector('.nt-success')){form.closest('.nt-form-section').scrollIntoView({block:'start'});}
});
}
init();
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());
document.addEventListener('shopify:section:load',event=>init(event.target));
})();
